import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { ReportService } from 'src/app/services/report/report.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent {
  @Input() public customReportId: number;
  isFormSubmitted = false;
  shareForm: FormGroup;

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  constructor(
    private appCoreService: AppCoreService,
    public activeModal: NgbActiveModal,
    private ngxLoaderService: NgxUiLoaderService,
    private router: Router,
    private formBuilder: FormBuilder,
    private reportService: ReportService,
    private titleService: Title
  ) {
    titleService.setTitle('Custom Report');
  }

  ngOnInit(): void {
    // Initialize form with custom validator
    this.shareForm = this.formBuilder.group({
      txtEmailIds: [null, Validators.compose([Validators.required, this.validateMultipleEmails.bind(this)])]
    });
    this.checkPermission();
  }

  checkPermission(): void {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter((x) => x.categoryname === 'CustomReports');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  // Validator to handle multiple emails
  validateMultipleEmails(control: any): ValidationErrors | null {
    if (!control.value) return null; // Skip validation if empty (required handles this)

    const emails = control.value.split(',').map((email) => email.trim()); // Split by comma and trim spaces
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Same as EmailValidation
    const invalidEmails = emails.filter((email) => !emailPattern.test(email)); // Check invalid emails

    return invalidEmails.length > 0 ? { invalidEmails: true } : null;
  }

  add(): void {
    this.isFormSubmitted = true;

    if (this.permConfig.isAddAllowed && this.shareForm.valid) {
      const emails = this.shareForm.get('txtEmailIds').value.split(',').map((email) => email.trim()); // Convert input to array

      const obj = {
        id: this.customReportId,
        emailids: emails
      };
      this.ngxLoaderService.start();
      try {
        // this.reportService.shareCutomReport(obj).subscribe(res => {
        //   if (res && res.success) {
        //     this.ngxLoaderService.stop();
        //     if (res.data?.missing && res.data?.missing.length > 0) {
        //       const sharedWith = `<strong>Shared with:</strong> ${res?.data?.inserted}`;
        //       const missingEmails = `<strong>Missing emails:</strong> ${res?.data?.missing.join(', ')}`;
        //       this.openSuccessDialog(`${sharedWith}<br>${missingEmails}`);
        //     } else {
        //       this.openSuccessDialog('Successfully Shared');
        //     }
        //     this.activeModal.close();
        //   }
        //   this.ngxLoaderService.stop();
        // }, (error) => {
        //   console.error("Error occurred:", error);
        //   this.ngxLoaderService.stop();
        // });
      } catch (err) {
        console.error(err);
        this.ngxLoaderService.stop();
      }
    } else {
      console.warn('Form is invalid or permission is not allowed.');
    }
  }

  async openSuccessDialog(msg: any) {
    const result = await Swal.fire({
      title: 'Success!',
      html: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      showCancelButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {
      this.router.navigate(['/reports/customreports']);
    }
  }


}
